<template>
    <ul class="mainmenu">
        <li><router-link to="/home" :style="index === 0 ? 'text-decoration: underline 0.5px;text-underline-offset: 4px;font-weight: 700;color: #A1FE04' : ''" class="father">Home</router-link></li>
        <li class="has-droupdown has-menu-child-item">
            <router-link to="/depost" :style="index === 1 ? 'text-decoration: underline 0.5px;text-underline-offset: 4px;font-weight: 700;color: #A1FE04' : ''" class="father">
                Deposit
            </router-link>
            <ul class="submenu">
                <li><router-link to="/depost/1" :class="subIndex === 'depost1' ? 'submenu-active' : ''">Deposite ETH<Icon name="check" v-if="subIndex === 'depost1'" style="float: right;"/></router-link></li>
                <li><router-link to="/depost/2" :class="subIndex === 'depost2' ? 'submenu-active' : ''">Withdraw ETH<Icon name="check" v-if="subIndex === 'depost2'" style="float: right;"/></router-link></li>
                <li><router-link to="/depost/3" :class="subIndex === 'depost3' ? 'submenu-active' : ''">ClaimReward ETH<Icon name="check" v-if="subIndex === 'depost3'" style="float: right;"/></router-link></li>
            </ul>
        </li>
        <li class="has-droupdown has-menu-child-item">
            <router-link to="/borrow" :style="index === 2 ? 'text-decoration: underline 0.5px;text-underline-offset: 4px;font-weight: 700;color: #A1FE04' : ''" class="father">
                Borrow
            </router-link>
            <ul class="submenu">
                <li><router-link to="/borrow/1" :class="subIndex === 'borrow1' ? 'submenu-active' : ''">Overview<Icon name="check" v-if="subIndex === 'borrow1'" style="float: right;"/></router-link></li>
                <li><router-link to="/borrow/2" :class="subIndex === 'borrow2' ? 'submenu-active' : ''">My Assets<Icon name="check" v-if="subIndex === 'borrow2'" style="float: right;"/></router-link></li>
                <li><router-link to="/borrow/3" :class="subIndex === 'borrow3' ? 'submenu-active' : ''">Rewards<Icon name="check" v-if="subIndex === 'borrow3'" style="float: right;"/></router-link></li>
            </ul>
        </li>
        <li class="has-droupdown has-menu-child-item">
            <router-link to="/auctions" :style="index === 3 ? 'text-decoration: underline 0.5px;text-underline-offset: 4px;font-weight: 700;color: #A1FE04' : ''" class="father">
                Auctions
            </router-link>
            <ul class="submenu">
                <li><router-link to="/auctions/1" :class="subIndex === 'auctions1' ? 'submenu-active' : ''">Overview<Icon name="check" v-if="subIndex === 'auctions1'" style="float: right;"/></router-link></li>
                <li><router-link to="/auctions/2" :class="subIndex === 'auctions2' ? 'submenu-active' : ''">Actioning<Icon name="check" v-if="subIndex === 'auctions2'" style="float: right;"/></router-link></li>
                <li><router-link to="/auctions/3" :class="subIndex === 'auctions3' ? 'submenu-active' : ''">Health Factor Alert List<Icon name="check" v-if="subIndex === 'auctions3'" style="float: right;"/></router-link></li>
                <li><router-link to="/auctions/4" :class="subIndex === 'auctions4' ? 'submenu-active' : ''">My Active Bids<Icon name="check" v-if="subIndex === 'auctions4'" style="float: right;"/></router-link></li>
            </ul>
        </li>
        <!-- <li class="has-droupdown has-menu-child-item">
            <a href="#">
                Home
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <ul class="submenu">
                <li><router-link to="/business-consulting">Business Consulting</router-link></li>
                <li><router-link to="/business-consulting-2">Business Consulting 02</router-link></li>
                <li><router-link to="/corporate">Corporate</router-link></li>
                <li><router-link to="/business">Business</router-link></li>
                <li><router-link to="/digital-agency">Digital Agency</router-link></li>
                <li><router-link to="/finance">Finance</router-link></li>
                <li><router-link to="/company">Company</router-link></li>
                <li><router-link to="/marketing-agency">Marketing Agency</router-link></li>
                <li><router-link to="/travel-agency">Travel Agency</router-link></li>
                <li><router-link to="/consulting">Consulting</router-link></li>
                <li><router-link to="/seo-agency">SEO Agency</router-link></li>
                <li><router-link to="/personal-portfolio">Personal Portfolio</router-link></li>
                <li><router-link to="/event-conference">Event Conference</router-link></li>
                <li><router-link to="/creative-portfolio">Creative Portfolio</router-link></li>
                <li><router-link to="/freelancer">Freelancer</router-link></li>
                <li><router-link to="/international-consulting">International Consulting</router-link></li>
                <li><router-link to="/startup">Startup</router-link></li>
                <li><router-link to="/web-agency">Web Agency</router-link></li>
            </ul>
        </li>
        <li><router-link to="/about">About</router-link></li>
        <li class="with-megamenu has-menu-child-item">
            <a href="#">
                Elements
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <div class="rn-megamenu">
                <div class="wrapper">
                    <div class="row row--0">
                        <div class="col-lg-3 single-mega-item">
                            <ul class="mega-menu-item">
                                <li><router-link to="/button">Button</router-link></li>
                                <li><router-link to="/service">Service</router-link></li>
                                <li><router-link to="/counter">Counter</router-link></li>
                                <li><router-link to="/progressbar">Progressbar</router-link></li>
                                <li><router-link to="/accordion">Accordion</router-link></li>
                                <li><router-link to="/social-share">Social Share</router-link></li>
                                <li><router-link to="/blog-grid">Blog Grid</router-link></li>
                            </ul>
                        </div>
                        <div class="col-lg-3 single-mega-item">
                            <ul class="mega-menu-item">
                                <li><router-link to="/team">Team</router-link></li>
                                <li><router-link to="/portfolio">Portfolio</router-link></li>
                                <li><router-link to="/testimonial">Testimonial</router-link></li>
                                <li><router-link to="/timeline">Timeline</router-link></li>
                                <li><router-link to="/tab">Tab</router-link></li>
                                <li><router-link to="/pricing">Pricing</router-link></li>
                                <li><router-link to="/spit-section">Split Section</router-link></li>
                            </ul>
                        </div>
                        <div class="col-lg-3 single-mega-item">
                            <ul class="mega-menu-item">
                                <li><router-link to="/call-to-action">Call To Action</router-link></li>
                                <li><router-link to="/video">Video</router-link></li>
                                <li><router-link to="/gallery">Gallery</router-link></li>
                                <li><router-link to="/contact">Contact</router-link></li>
                                <li><router-link to="/brand">Brand</router-link></li>
                                <li><router-link to="/portfolio">Portfolio</router-link></li>
                                <li><router-link to="/error">404</router-link></li>
                            </ul>
                        </div>
                        <div class="col-lg-3 single-mega-item">
                            <ul class="mega-menu-item">
                                <li>
                                    <router-link to="/advance-tab">
                                        Advance Tab <span class="rn-badge-card">Hot</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="#">
                                        Brand Carousel <span class="rn-badge-card">Comming</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/advance-pricing">
                                        Advance Pricing <span class="rn-badge-card">Hot</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/portfolio-details/1">
                                        Portfolio Details
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/blog-details/1">
                                        Blog Details
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </li>
        <li class="has-droupdown has-menu-child-item">
            <a href="#">
                Blog
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <ul class="submenu">
                <li><router-link to="/blog-grid">Blog Grid</router-link></li>
                <li><router-link to="/blog-grid-sidebar">Blog Grid Sidebar</router-link></li>
                <li><router-link to="/blog-list">Blog List View</router-link></li>
                <li><router-link to="/blog-list-sidebar">Blog List View Sidebar</router-link></li>
            </ul>
        </li>
        <li class="has-droupdown has-menu-child-item">
            <a href="#">
                Portfolio
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <ul class="submenu">
                <li><router-link to="/portfolio">Portfolio Default</router-link></li>
                <li><router-link to="/portfolio-three-column">Portfolio Three Column</router-link></li>
                <li><router-link to="/portfolio-full-width">Portfolio Full Width</router-link></li>
                <li><router-link to="/portfolio-grid-layout">Portfolio Grid Layout</router-link></li>
                <li><router-link to="/portfolio-box-layout">Portfolio Box Layout</router-link></li>
            </ul>
        </li>
        <li><router-link to="/contact">Contact</router-link></li> -->
    </ul>
</template>

<script>
    import Icon from "../../icon/Icon";
    export default {
        name: 'Nav',
        components: {Icon},
        data() {
            return {
                index: 0,
                subIndex: ''
            }
        },
        watch: {
            "$route"(to, from) {
                const name = to.name
                const fullPath = to.fullPath
                switch (name) {
                    case 'Home': this.index = 0; break
                    case 'Depost': this.index = 1; break
                    case 'Borrow': this.index = 2; break
                    case 'Auctions': this.index = 3; break
                    default: break
                }
                switch (fullPath) {
                    case '/depost/1': this.subIndex = 'depost1'; break
                    case '/depost/2': this.subIndex = 'depost2'; break
                    case '/depost/3': this.subIndex = 'depost3'; break
                    case '/borrow/1': this.subIndex = 'borrow1'; break
                    case '/borrow/2': this.subIndex = 'borrow2'; break
                    case '/borrow/3': this.subIndex = 'borrow3'; break
                    case '/auctions/1': this.subIndex = 'auctions1'; break
                    case '/auctions/2': this.subIndex = 'auctions2'; break
                    case '/auctions/3': this.subIndex = 'auctions3'; break
                    case '/auctions/4': this.subIndex = 'auctions4'; break
                    default: break
                }
            }
        },
        mounted() {
            const name = this.$route.name
            const fullPath = this.$route.fullPath
            switch (name) {
                case 'Home': this.index = 0; break
                case 'Depost': this.index = 1; break
                case 'Borrow': this.index = 2; break
                case 'Auctions': this.index = 3; break
                default: break
            }
            switch (fullPath) {
                case '/depost/1': this.subIndex = 'depost1'; break
                case '/depost/2': this.subIndex = 'depost2'; break
                case '/depost/3': this.subIndex = 'depost3'; break
                case '/borrow/1': this.subIndex = 'borrow1'; break
                case '/borrow/2': this.subIndex = 'borrow2'; break
                case '/borrow/3': this.subIndex = 'borrow3'; break
                case '/auctions/1': this.subIndex = 'auctions1'; break
                case '/auctions/2': this.subIndex = 'auctions2'; break
                case '/auctions/3': this.subIndex = 'auctions3'; break
                case '/auctions/4': this.subIndex = 'auctions4'; break
                default: break
            }
        },
    }
</script>